let elementTypes: { [key in server.dto.FormElementTypes]?: server.dto.FormElementType } = null;

export const getFormElementType = (type: server.dto.FormElementTypes) => {
  if (elementTypes == null) {
    elementTypes = serverReference.formElementTypes.reduce((acc, curr) => {
      acc[curr.value] = curr;
      return acc;
    }, {});
  }

  return elementTypes[type];
}

const translationOrder: server.dto.Languages[] = [
  "english",
  "dutch",
  "german",
  "spanish",
  "portuguese",
  "italian"
]

const compareTranslationValues = (a: server.dto.TranslationValue, b: server.dto.TranslationValue): number => {
  return translationOrder.indexOf(a.language) - translationOrder.indexOf(b.language);
}

export const sortTranslationValues = (values: server.dto.TranslationValue[]) => {
  return values.sort(compareTranslationValues);
}

export const removeEmptyTranslationValues = (values: server.dto.TranslationValue[]) => {
  return values.filter(v => v.value.trim() !== "");
}

export const sortAndPadTranslationValues = (values: server.dto.TranslationValue[]) => {
  const sortedValues = sortTranslationValues(values);
  const paddedValues: server.dto.TranslationValue[] = [];

  translationOrder.forEach(language => {
    const value = sortedValues.find(v => v.language === language);
    if (value) {
      paddedValues.push(value);
    } else {
      paddedValues.push({ language, value: "" });
    }
  });

  return paddedValues;
}